export class DCCompanyBusinessPriority {
  "DC Business Priorities": string = "";
  "Id": string = "";
}

export class ListOfDCCompanyBusinessPrioritiesBC {
  "DC Company Business Priorities BC": DCCompanyBusinessPriority[] = [];
}

export class DCCompanyProfileBC {
  "DC Legal Company Name": string = "";
  "DC Sector/Industry": string = "";
  "DC Other Sector/Industry": string = "";
  "DC Number of Employees": string = "";
  "DC Website": string = "";
  "DC LinkedIn": string = "";
  "DC Other": string = "";
  "DC Preferred Communication Channel": string = "";
  "DC Industry servey Flag": string = "";
  "DC Pramotion update  Flag": string = "";
  "ListOfDC Company Business Priorities BC": ListOfDCCompanyBusinessPrioritiesBC =
    new ListOfDCCompanyBusinessPrioritiesBC();
}

export class ListOfDCCompanyProfileIO {
  "DC Company Profile BC": DCCompanyProfileBC = new DCCompanyProfileBC();
}

export class CompanyProfileSiebelMessage {
  xmlns: string = "http://www.siebel.com/xml/DC%20Query%20Member%20Info";
  MessageId: string = "";
  MessageType: string = "Integration Object";
  IntObjectName: string = "DCCompanyProfileIO";
  IntObjectFormat: string = "Siebel Hierarchical";
  ListOfDCCompanyProfileIO: ListOfDCCompanyProfileIO =
    new ListOfDCCompanyProfileIO();
}

export class CompanyProfileRequestBody {
  ProcessName: string = "DC Create Company Profile WF";
  "DCMethod": string = "SETPROFILE";
  "DC Channel": string = "Online";
  "AccountId": string = "";
  SiebelMessage: CompanyProfileSiebelMessage = new CompanyProfileSiebelMessage();
}

export class CompanyProfileRequest {
  body: CompanyProfileRequestBody = new CompanyProfileRequestBody();
}
